var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":"warning","size":_vm.size}},[(!_vm.author_isAuthorPhotoExist)?_c('span',{staticClass:"white--text body-2"},[_vm._v(_vm._s(_vm.author_LettersName))]):_vm._e(),(_vm.author_isAuthorPhotoExist)?_c('img',{attrs:{"src":_vm.author_authorPhotoThumbnail,"alt":_vm.author_fullName}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }